/* eslint-disable no-param-reassign */
import { uuid } from 'uuidv4';

const configurationRulesSlice = (set) => ({
  configurationRules: {
    loading: true,
    returnReasons: null,
    categories: null,
    storeConfigs: null,
    fetched: {
      returnReasons: null,
      categories: null,
      storeConfigs: null,
    },
    setLoading: (loading) => {
      set((state) => {
        state.configurationRules.loading = loading;
      });
    },
    setFetched: (rules) => {
      set((state) => {
        state.configurationRules.fetched.returnReasons = rules.returnReasons;
        state.configurationRules.fetched.categories = rules.categories;
        state.configurationRules.fetched.storeConfigs = rules.storeConfigs;
        state.configurationRules.returnReasons = rules.returnReasons;
        state.configurationRules.categories = rules.categories;
        state.configurationRules.storeConfigs = rules.storeConfigs;
      });
    },
    discardChanges: () => {
      set((state) => {
        state.configurationRules.returnReasons =
          state.configurationRules.fetched.returnReasons;
        state.configurationRules.categories =
          state.configurationRules.fetched.categories;
        state.configurationRules.storeConfigs =
          state.configurationRules.fetched.storeConfigs;
      });
    },
    toggleReturnReasonSelection: (id) => {
      set((state) => {
        const index = state.configurationRules.returnReasons.findIndex(
          (reason) => reason.id === id,
        );
        if (index > -1) {
          state.configurationRules.returnReasons[index].isSelected =
            !state.configurationRules.returnReasons[index].isSelected;
        }
      });
    },
    addReturnReason: (reasonDescription) => {
      set((state) => {
        state.configurationRules.returnReasons = [
          ...state.configurationRules.returnReasons,
          {
            id: uuid(),
            description: reasonDescription,
            isSelected: true,
          },
        ];
      });
    },
    removeReturnReason: (id) => {
      set((state) => {
        state.configurationRules.returnReasons =
          state.configurationRules.returnReasons.filter(
            (reason) => reason.id !== id,
          );
      });
    },
    setDevolutionPreferenceSelection: (key, checked) => {
      set((state) => {
        state.configurationRules.storeConfigs[key] = checked;
      });
    },
    setReturnWindow: (days) => {
      set((state) => {
        state.configurationRules.storeConfigs.returnWindowDays = days;
      });
    },
    toggleCategorySelection: (index) => {
      set((state) => {
        const targetCategory = state.configurationRules.categories[index];
        targetCategory.eligible = !targetCategory.eligible;
        state.configurationRules.categories[index] = targetCategory;
      });
    },
  },
});

export default configurationRulesSlice;
